import { memo } from 'react'

/**
 * Copy/paste code indicator icon
 */
export const COPYCODESVG = memo(() => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10.5" cy="10.5" r="10" fill={'#FFF'} stroke="currentColor" />
      <path
        d="M12.2 8.14996H6.2C5.5382 8.14996 5 8.68816 5 9.34996V15.35C5 16.0118 5.5382 16.55 6.2 16.55H12.2C12.8618 16.55 13.4 16.0118 13.4 15.35V9.34996C13.4 8.68816 12.8618 8.14996 12.2 8.14996Z"
        fill="currentColor"
      />
      <path
        d="M15.3523 5H9.35234C9.03408 5 8.72886 5.12643 8.50382 5.35147C8.27877 5.57652 8.15234 5.88174 8.15234 6.2V7.4H12.9523C13.2706 7.4 13.5758 7.52643 13.8009 7.75147C14.0259 7.97652 14.1523 8.28174 14.1523 8.6V13.4H15.3523C15.6706 13.4 15.9758 13.2736 16.2009 13.0485C16.4259 12.8235 16.5523 12.5183 16.5523 12.2V6.2C16.5523 5.88174 16.4259 5.57652 16.2009 5.35147C15.9758 5.12643 15.6706 5 15.3523 5Z"
        fill="currentColor"
      />
    </svg>
  )
})

/**
 * Run code indicator icon
 */
export const RUNCODESVG = memo(() => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="9.5" fill={'#FFF'} stroke="currentColor" />
      <path
        d="M7 15.0384V5.12897C7 4.28216 7.98678 3.81866 8.6385 4.35935L15.0088 9.64436C15.5112 10.0612 15.4861 10.8398 14.9578 11.2232L8.58746 15.8476C7.92639 16.3275 7 15.8553 7 15.0384Z"
        fill="currentColor"
      />
    </svg>
  )
})

/**
 * IP address switch/change indicator icon
 */
export const IPSWITCHEDSVG = memo(() => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10.5" cy="10.5" r="10" fill={'#FFF'} stroke="currentColor" />
      <path
        d="M11 4C8.79143 4 7 5.881 7 8.2C7 11.35 11 17 11 17C11 17 15 11.35 15 8.2C15 5.881 13.2086 4 11 4ZM11 9.7C10.2114 9.7 9.57143 9.028 9.57143 8.2C9.57143 7.372 10.2114 6.7 11 6.7C11.7886 6.7 12.4286 7.372 12.4286 8.2C12.4286 9.028 11.7886 9.7 11 9.7Z"
        fill="currentColor"
      />
    </svg>
  )
})

/**
 * Tab switch indicator icon
 */
export const TABSWITCHSVG = memo(() => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 460.893 460.893"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M420.84,0H160.051c-18.121,0-32.864,14.743-32.864,32.865v76.136c9.398,0,296.519-0.163,296.519-0.163v184.815
      c0,1.58-1.285,2.865-2.865,2.865h-57.135v30h57.135c18.122,0,32.865-14.743,32.865-32.865V32.865
      C453.705,14.743,438.962,0,420.84,0z M157.186,78.838V32.865c0-1.58,1.285-2.865,2.864-2.865h260.789
      c1.58,0,2.865,1.285,2.865,2.865v45.973H157.186z"
        />
        <circle cx="183.835" cy="56.556" r="18.1" />
        <path
          d="M300.84,134.375c-8.756,0-252.622,0-260.789,0c-18.109,0-32.864,14.717-32.864,32.864v260.789
      c0,18.12,14.742,32.865,32.864,32.865H300.84c18.118,0,32.865-14.739,32.865-32.865V167.239
      C333.705,149.098,318.952,134.375,300.84,134.375z M37.186,167.239c0-1.579,1.285-2.864,2.864-2.864h260.789
      c1.58,0,2.865,1.285,2.865,2.864v45.974H37.186V167.239z M303.706,428.028h-0.001c0,1.58-1.285,2.865-2.865,2.865H40.051
      c-1.579,0-2.864-1.285-2.864-2.865V243.213h266.519V428.028z"
        />
        <circle cx="64.835" cy="188.931" r="18.1" />
      </g>
    </svg>
  )
})

/**
 * No face detected indicator icon
 */
export const NOFACESDETECTEDSVG = memo(() => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />

      <circle cx="8.5" cy="9" r="1.6" fill="currentColor" />
      <circle cx="15.5" cy="9" r="1.6" fill="currentColor" />

      <path
        d="M8 15c1.5 1.5 6.5 1.5 8 0"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />

      <line
        x1="5"
        y1="5"
        x2="19"
        y2="19"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  )
})

/**
 * View remark indicator icon
 */
export const VIEWREMARKSVG = memo(() => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5 1a4 4 0 0 0-4 4v14a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4V5a4 4 0 0 0-4-4zm1.653 17.387l.002-.002l.008-.007l.032-.032a5 5 0 0 0 .494-.575c.236-.32.435-.675.494-.997c-1.91-1.163-3.183-3.092-3.183-5.298C4.5 7.852 7.91 5 12 5s7.5 2.853 7.5 6.477s-3.41 6.478-7.5 6.478c-.572 0-1.13-.056-1.666-.16c-.405.575-1.044.884-1.651 1.044a5.3 5.3 0 0 1-1.835.136l-.734-.082l.54-.505Z"
        clipRule="evenodd"
      />
    </svg>
  )
})

/**
 * Developer tag indicator icon
 */
export const DEVELOPERTAGSVG = memo(() => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M5.15 18.85q-1.025-1.2-1.588-2.687T3 13q0-3.75 2.625-6.375T12 4h.2l-1.6-1.6L12 1l4 4l-4 4l-1.425-1.425L12.15 6H12Q9.1 6 7.05 8.05T5 13q0 1.275.412 2.4t1.163 2.025zM11 18.5q0-.575-.387-1.137t-.863-1.175t-.862-1.275T8.5 13.5q0-1.45 1.025-2.475T12 10t2.475 1.025T15.5 13.5q0 .75-.387 1.413t-.863 1.274t-.862 1.175T13 18.5zm0 2.5v-1.5h2V21zm7.85-2.15l-1.425-1.425q.75-.9 1.163-2.025T19 13q0-1.65-.687-3.062t-1.888-2.363L17.85 6.15q1.45 1.25 2.3 3.013T21 13q0 1.675-.562 3.163T18.85 18.85"
      />
    </svg>
  )
})

/**
 * Exit/Manual leave indicator icon
 */
export const EXITSVG = memo(() => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="m12 15l3-3m0 0l-3-3m3 3H4m0-4.752V7.2c0-1.12 0-1.68.218-2.108c.192-.377.497-.682.874-.874C5.52 4 6.08 4 7.2 4h9.6c1.12 0 1.68 0 2.107.218c.377.192.683.497.875.874c.218.427.218.987.218 2.105v9.607c0 1.118 0 1.677-.218 2.104a2 2 0 0 1-.875.874c-.427.218-.986.218-2.104.218H7.197c-1.118 0-1.678 0-2.105-.218a2 2 0 0 1-.874-.874C4 18.48 4 17.92 4 16.8v-.05"
      />
    </svg>
  )
})

/**
 * Stage finished/completed indicator icon
 */
export const STAGEFINISHEDSVG = memo(() => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 2048 2048"
    >
      <path
        fill="#38a61e"
        d="M1024 0q141 0 272 36t244 104t207 160t161 207t103 245t37 272q0 141-36 272t-104 244t-160 207t-207 161t-245 103t-272 37q-141 0-272-36t-244-104t-207-160t-161-207t-103-245t-37-272q0-141 36-272t104-244t160-207t207-161T752 37t272-37m603 685l-136-136l-659 659l-275-275l-136 136l411 411z"
      />
    </svg>
  )
})
